<div class="wrapper" fxLayout="column" fxLayoutAlign="center center">
  <form (ngSubmit)="submit()" [formGroup]="form" fxLayout="column" ngClass.xs="xs-padding-bar" fxLayoutGap="8px">
    <mat-form-field appearance="outline">
      <mat-label>Mobile phone number</mat-label>
      <input matInput placeholder="Enter your mobile phone number" autocomplete="tel" required formControlName="mobilePhone"
        mask="(000) 000-0000">
      <mat-error>
        Incorrect mobile phone number.
      </mat-error>
    </mat-form-field>


    <mat-form-field appearance="outline">
      <mat-label>Home phone number</mat-label>
      <input matInput placeholder="Enter your home phone number" autocomplete="tel" formControlName="homePhone"
        mask="(000) 000-0000">
      <mat-error>
        Incorrect home phone number.
      </mat-error>
    </mat-form-field>


    <mat-form-field appearance="outline">
      <mat-label>Preferred phone number</mat-label>
      <input matInput placeholder="Enter your preferred phone number" autocomplete="tel" required formControlName="preferredPhone"
        mask="(000) 000-0000">
      <mat-error>
        Incorrect preferred phone number.
      </mat-error>
    </mat-form-field>

    <div formGroupName="address" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="8px">
      <ifc-google-places-autocomplete-form-field
        [control]="form.get('address.line1')"
        fieldType="street"
        (placeSelected)="handleAddressChange($event)">
      </ifc-google-places-autocomplete-form-field>

      <mat-form-field appearance="outline" fxFlex>
        <mat-label>Unit/Suite/Apt #</mat-label>
        <input matInput autocomplete="address-line2" formControlName="line2">
      </mat-form-field>

      <div class="address">
        <ifc-google-places-autocomplete-form-field
          [control]="form.get('address.city')"
          fieldType="city"
          cssClass="address__item"
          (placeSelected)="handleCityAddressChange($event)">
        </ifc-google-places-autocomplete-form-field>

        <mat-form-field appearance="outline" class="address__item">
          <mat-label>State</mat-label>
          <mat-select placeholder="State" formControlName="state">
            <mat-option *ngFor="let state of states" [value]="state">
              {{state}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="address__item">
          <mat-label>Zip</mat-label>
          <input matInput placeholder="Enter your zip" autocomplete="postal-code" required formControlName="zip">
          <mat-error>
            Incorrect zip code format.
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="end start" fxLayoutGap="8px">
      <button mat-button routerLink="/home" type="button">Cancel</button>
      <button mat-flat-button color="primary" type="submit"
        [disabled]="submitSub || !form.touched">Save</button>
    </div>

  </form>
</div>
